import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Page} from '../../../data/models/page';
import {TestResult, TestResultsSummary} from '../../../data/models/result/test-result';
import {TestResultFilters} from '../../../data/models/filters/test-result-filters';

@Injectable({
  providedIn: 'root'
})
export class TestResultService {

  constructor(
    private http: HttpClient,
  ) {
  }

  getTestResult(testResultId: number): Promise<TestResult> {
    return this.http.get<TestResult>(`api/test-results/${testResultId}`)
      .toPromise();
  }

  searchTestResults(
    filters: TestResultFilters,
    sort: string[], pageSize = 50, pageNumber = 0
  ): Promise<Page<TestResult>> {

    let httpParams = new HttpParams()
      .set('size', pageSize.toString())
      .set('page', pageNumber.toString());

    if (filters.testId) {
      httpParams = httpParams.set('testId', filters.testId.toString());
    }

    if (filters.search && filters.search.length > 0) {
      httpParams = httpParams.set('search', filters.search);
    }

    if (filters.isFinished !== undefined && filters.isFinished !== null) {
      httpParams = httpParams.set('isFinished', filters.isFinished.toString());
    }

    if (filters.isChecked !== undefined && filters.isChecked !== null) {
      httpParams = httpParams.set('isChecked', filters.isChecked.toString());
    }

    if (sort.length > 0) {
      httpParams = httpParams.set('sort', sort.join(','));
    }

    return this.http.get<Page<TestResult>>(`api/test-results`, {
      params: httpParams
    }).toPromise();
  }

  getTestResultsSummary(): Promise<TestResultsSummary> {
    return this.http.get<TestResultsSummary>(`api/test-results/summary`)
      .toPromise();
  }

  commitTestResult(testResultId: number): Promise<TestResult> {
    return this.http.post<TestResult>(`api/test-results/${testResultId}/actions/commit`, new FormData())
      .toPromise();
  }

  cancelTestResult(testResultId: number): Promise<TestResult> {
    return this.http.post<TestResult>(`api/test-results/${testResultId}/actions/cancel`, new FormData())
      .toPromise();
  }

  deleteTestResult(testResultId: number): Promise<void> {
    return this.http.delete<void>(`api/test-results/${testResultId}`)
      .toPromise();
  }
}
